export default __webpack_public_path__ + "48f6726b259029893b7054c864237752.png";